import React from 'react';
import { Box } from '@mui/material';
import { ClipboardList } from 'lucide-react';
import type { IParticipantCardData } from '../../interfaces';
import { AssessmentCard, CardSkeletonGrid, EmptyState } from '../components';

export interface IAssessmentsTabProps {
  assessments: IParticipantCardData[];
  loading: boolean;
}

export const AssessmentsTab = ({ assessments, loading }: IAssessmentsTabProps) => {
  if (loading) {
    return <CardSkeletonGrid count={6} height={320} />;
  }

  if (assessments.length === 0) {
    return (
      <EmptyState
        icon={ClipboardList}
        title="No Assessments Assigned"
        subtitle="Assessments assigned to you will appear here."
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 3,
      }}
    >
      {assessments.map((assessment, index) => (
        <AssessmentCard userAssessment={assessment} key={assessment.id || index} />
      ))}
    </Box>
  );
};
